module.exports = __webpack_public_path__ + "img/torso-pouch.8e3ce338.png";